import { all, call, take, fork, delay } from 'redux-saga/effects';
import { eventChannel } from 'redux-saga';
import { AnalyticsInstance } from '@ts/utils/analytics';

const directImpressions = AnalyticsInstance.impression.dispatch;

export function createImpressionsInterceptor() {
    return eventChannel((emitter) => {
        const prev = AnalyticsInstance.impression.dispatch;
        AnalyticsInstance.impression.dispatch = (...args) => emitter({ type: 'impressions', args });
        return () => {
            AnalyticsInstance.impression.dispatch = prev;
        };
    });
}

export function* createImpressionsInterceptChannels() {
    let impressions = [];
    function* accumulator() {
        const chan = yield call(createImpressionsInterceptor);
        while (true) {
            const event = yield take(chan);
            if (event.type === 'impressions' && event.args[0]) {
                const items = Array.isArray(event.args[0]) ? event.args[0] : [event.args[0]];
                impressions = impressions.concat(items);
            }
        }
    }

    function* pusher() {
        while (true) {
            yield delay(1500);
            if (impressions.length > 0) {
                directImpressions(impressions);
                impressions = [];
            }
        }
    }

    return yield all([fork(accumulator), fork(pusher)]);
}

export default function* analyticsSaga() {
    yield all([fork(createImpressionsInterceptChannels)]);
}
